import React from "react";

import { Card } from "@mui/material";

const MUICard = (props) => {
  return (
    <Card sx={{ padding: "1.5rem", gap: "1.5rem" }}>{props.children}</Card>
  );
};

export default MUICard;
